import { useState } from "react";
import GlobalStudentActivityReportList from '../../pages/common/globalstudentactivityreportlist';
import GlobalStudentActivityList from '../../pages/common/globalstudentactivitylist';
import { useAuth } from '../../../usercontext';
import { Tab, Nav } from 'react-bootstrap';

const StudentActivitiesAndReportsList = () => {
	const { profile } = useAuth();
	const studentId = profile.id;
	const [activeTab, setActiveTab] = useState('studentActivities');

	return (
		<div>
			<Tab.Container
				defaultActiveKey='programdetails'
				activeKey={activeTab}
				onSelect={(k) => setActiveTab(k)}
			>
				<Nav variant='tabs'>
					<Nav.Item>
						<Nav.Link eventKey='studentActivities'>Student Activities</Nav.Link>
					</Nav.Item>
					<Nav.Item>
						<Nav.Link eventKey='studentActivityReports'> Student Activity Reports</Nav.Link>
					</Nav.Item>
				</Nav>
				<Tab.Content>
					<Tab.Pane eventKey='studentActivities'>
						<GlobalStudentActivityList
							slug={studentId}
							isStudent={true}
							studentRole={profile?.role}
						/>
					</Tab.Pane>
					<Tab.Pane eventKey='studentActivityReports'>
						<GlobalStudentActivityReportList studentId={studentId} />
					</Tab.Pane>
				</Tab.Content>
			</Tab.Container>
		</div>
	);
};

export default StudentActivitiesAndReportsList;
